import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from 'react-router-dom';
import clsx from 'clsx';

import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import ButtonPrimary from "@base/Button";
import Title from '@base/Title';
import Toast from '@base/Toast';
import TextField from '@base/Inputs/Text';
import ButtonHelp from "@base/Button/ButtonHelp";

import ObjetoPostalService from '@services/ObjetoPostalService';
import CaixaService from '@services/CaixaService';

import ArmazenarTableView from '@pages/Armazenar/ArmazenarTableView'
import ArmazenarCaixaDialog from '@pages/Armazenar/ArmazenarCaixaDialog'
import ArmazenarObjetoPostalDialog from '@pages/Armazenar/ArmazenarObjetoPostalDialog'
import MudarEnvelopeDeCaixaDialog from '@pages/Armazenar/MudarEnvelopeDeCaixaDialog'

import { ProcessoResolver } from '@helpers/ProcessoHelper';

import DoneAllIcon from '@material-ui/icons/DoneAll';
import { isNotNumber, isNotObjetoPostal } from "@helpers/ValidationHelper";

const __ENVELOPE_LENGTH = 13;

const useStyles = makeStyles(
  (theme) => (
    {
      wrapper: {
        padding: theme.spacing(3),
      },
      space: {
        margin: theme.spacing(2, 0),
      },
      title: {
        color: "#333",
        fontSize: 24,
      }
    }
  )
);

export const Armazenar = () => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [caixaCodigo, setCaixaCodigo] = useState('');
  const [numeroObjetoPostal, setNumeroObjetoPostal] = useState('');
  const [formularioSelecionado, setFormularioSelecionado] = useState(false);
  const [openArmazenarCaixaDialog, setOpenArmazenarCaixaDialog] = useState(false);
  const [openArmazenaEnvelopeDialog, setOpenArmazenarEnvelopeDialog] = useState(false);
  const [openDialogMudarEnvelopeDeCaixa, setOpenDialogMudarEnvelopeDeCaixa] = useState(false);
  const [statusArmazenada, setStatusArmazenada] = useState(false);
  const [erro, setErro] = useState('');
  const [statusMensagem, setStatusMensagem] = useState('');

  const [objetoPostal, setObjetoPostal] = useState('');


  const [disableInputCaixa, setDisableInputCaixa] = useState(false);

  const [filtros, setFiltros] = useState([]);
  const [filtroAtivo, setFiltroAtivo] = useState(false);

  const params = useParams();
  const processo = ProcessoResolver(params.processo);

  const toastRef = useRef(null);
  const dialogMudarEnvelopeDeCaixaRef = useRef(null);
  const objetoPostalInputRef = useRef(null);

  //TODO bloquear letras
  const isCaixaInvalida = (id) => {
    if (!id) return `<li>O campo 'Código da Caixa' é obrigatório.</li>`;
    if (isNotNumber(id)) return `<li>O campo 'Código da Caixa' deve ser Numérico.</li>`;
  }

  const isObjetoPostalInvalido = (id) => {
    if (!id) return `<li>O campo 'Número do Objeto Postal' é obrigatório.</li>`;
    if (isNotObjetoPostal(id)) return `<li>O campo 'Número do Objeto Postal' precisa estar no formato <b>XX000000000XX</b>.</li>`;
  }

  const carregaCaixa = (id) => {
    setCaixaCodigo(id);
    const caixaInvalida = isCaixaInvalida(id);
    if (caixaInvalida) {
      toastRef.current.show("error", caixaInvalida);
      return
    }

    if (id.length === 4) {
      CaixaService.buscarPorId(processo.id, id)
        .then(resposta => {
          if (resposta.status === 200) {

            setFormularioSelecionado(true)

            resposta.data.status === "ARMAZENADA" ? setStatusArmazenada(true) : setDisableInputCaixa(true);
          } else {
            alert("Caixa inexistente");
          }
        });
    }

  }

  const limparCamposParaArmazenarOutroEnvelope = () => {
    setDisableInputCaixa(true);
    setFormularioSelecionado(true);
    setNumeroObjetoPostal('');
    setObjetoPostal('');

    setTimeout(() => {
      objetoPostalInputRef.current?.focus();
    }, 0);
  }

  const armazenarCaixa = () => {
    const objeto = {
      'processoId': processo.id,
      'caixaId': caixaCodigo
    };
    CaixaService.armazenarCaixa(objeto).then(() => {
      toastRef.current.show("success", `Caixa ${caixaCodigo} armazenada.`);
      aplicarFiltros();
      limparCamposParaArmazenarOutroEnvelope();
      setCaixaCodigo('');
    }).catch(error => toastRef.current.show("error", error.response.data.mensagens !== undefined ? error.response.data.mensagens.map(mensagem => mensagem).join(" ,") : "Ocorreu um problema ao Registrar Armazenamento"))
  }

  const armazenaEnvelopeNaCaixa = (id) => {
    id = id?.toUpperCase();

    setNumeroObjetoPostal(id);
    setLoading(true);

    if (id.length < 13) {
			setLoading(false);
			return
		}

    const objetoPostalInvalido = isObjetoPostalInvalido(id);

    if (objetoPostalInvalido) {
      toastRef.current.show("error", objetoPostalInvalido);
      setLoading(false);
      return
    }

    ObjetoPostalService.getByProcessoAndNumeroObjetoPostal(processo.id, id)
      .then(result => {

        setObjetoPostal(result.data);

        if (result.data.caixaCodigo !== null && result.data.caixaCodigo !== parseInt(caixaCodigo) && result.data.status === "FINALIZADO") {
          setOpenDialogMudarEnvelopeDeCaixa(true);
        } else{
          armazenamentoEnvelope(result.data);
        }

      }).catch(error => {
         setErro(error.response.data.mensagens !== undefined ?
          error.response.data.mensagens.map(mensagem => mensagem).join(" ,") :
         `Não foi possível encontrar o envelope ${id}.`);
          setOpenArmazenarEnvelopeDialog(true);
          setLoading(false);
         limparCamposParaArmazenarOutroEnvelope();

      });

     
      
  }

	const armazenamentoEnvelope = (objetoPostal) => {

    setOpenDialogMudarEnvelopeDeCaixa(false);

    const op = {
      'processoId': processo.id,
      'objetoPostalId': objetoPostal.id,
      'status': objetoPostal.status,
      'caixaCodigo': caixaCodigo
    };

    ObjetoPostalService.registrarArmazenamento(op)
    .then(() => {
      toastRef.current.show("success", `Envelope ${objetoPostal.numeroObjetoPostal} armazenado com sucesso.`);
      aplicarFiltros();
    })
    .catch(error => {

      if (error.response.data.mensagens !== undefined) {
        let regex = new RegExp(objetoPostal.numeroObjetoPostal);
        if (error.response.data.mensagens.map(mensagem => mensagem).join(" ,").match(regex)) {
          switch (objetoPostal.status) {
            case "RECEBIDO":
              setStatusMensagem('Triagem');
              break;
            case "TRIADO":
              setStatusMensagem('Lançamento');
              break;
            case "LANCADO":
              setStatusMensagem('Digitalização');
              break;
            case "EM_RECONTAGEM":
              setStatusMensagem('Recontagem');
              break;
            default:
              setStatusMensagem('Digitalização');
          }
          setErro(error.response.data.mensagens + ' ');
          setOpenArmazenarEnvelopeDialog(true);
        }else{
          setErro(error.response.data.mensagens.map(mensagem => mensagem).join(" ,"));
          setOpenArmazenarEnvelopeDialog(true);
        }
      } else {
        setErro(`Não foi possível armazenar o envelope ${objetoPostal.numeroObjetoPostal}.`);
          setOpenArmazenarEnvelopeDialog(true);

      }
    })
    .finally(() => {
      setLoading(false);
      limparCamposParaArmazenarOutroEnvelope();
    });
	}

  const aplicarFiltros = useCallback(() => {
    let f = [];

    f.push({ field: 'codigoCaixa', value: caixaCodigo });
    f.push({ field: 'dataArmazenamento', value: "true" })
    setFiltros(f);
    setFiltroAtivo(false);
  }, [caixaCodigo]);

  useEffect(() => {
    if (caixaCodigo)
      aplicarFiltros();
  }, [caixaCodigo, aplicarFiltros]);

  return (
    <>
      <Toast ref={toastRef} />
      <Title>Armazenamento de Caixas <ButtonHelp tipo="ARMAZENAMENTO" /></Title>

      <Paper className={classes.wrapper} elevation={0} spacing={2}>
        <Grid alignItems="center" container>
          <Grid item sm={2}>
            <TextField
              autoFocus={!disableInputCaixa}
              inputProps={{
                maxLength: 10
              }}
              label={"Código da Caixa"}
              value={caixaCodigo}
              onChange={(e) => carregaCaixa(e.target.value)}
              disabled={disableInputCaixa}
              onKeyPress={(e) => e}
            />
          </Grid>
        </Grid>
      </Paper>

      {formularioSelecionado &&
        <>
          <Paper className={classes.wrapper} elevation={0} spacing={2}>
            <Grid alignItems="center" container>
              <Grid item sm={4}>
                <TextField
                  autoFocus
                  id="objetoPostal"
                  inputProps={{ maxLength: __ENVELOPE_LENGTH }}
                  label={"Número do Objeto Postal"}
                  value={numeroObjetoPostal}
                  onChange={(e) => armazenaEnvelopeNaCaixa(e.target.value)}
                  onKeyPress={(e) => e}
                  disabled={statusArmazenada || loading}
                  helperText="Exemplo de Formato: XX000000000XX"
                  inputRef={objetoPostalInputRef}
                />
              </Grid>
            </Grid>
          </Paper>

          <Paper className={clsx(classes.wrapper, classes.space)}>
            <Title style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <b>Envelopes na CAIXA {caixaCodigo} {statusArmazenada ? " (ARMAZENADA)" : ""}</b>
              <ButtonPrimary
                style={{ marginLeft: '24px' }}
                onClick={() => setOpenArmazenarCaixaDialog(true)}
                name="Armazenar Caixa"
                startIcon={loading ? <CircularProgress size={16} /> : <DoneAllIcon />}
                disabled={loading || statusArmazenada}
              />
            </Title>

            <Grid alignItems="center" container spacing={2}>
              <ArmazenarTableView
                processo={processo.id}
                caixaCodigo={caixaCodigo}
                filtros={filtros}
                filtroAtivo={filtroAtivo}
                setFiltroAtivo={setFiltroAtivo}
              />
            </Grid>
          </Paper>
        </>
      }

      {openArmazenarCaixaDialog && caixaCodigo && caixaCodigo !== "" &&
        <>
          <ArmazenarCaixaDialog
            caixaAtual={caixaCodigo}
            style={{ height: 500 }}
            close={() => {
              limparCamposParaArmazenarOutroEnvelope();
              setOpenArmazenarCaixaDialog(false)
            }}
            open={openArmazenarCaixaDialog}
            title={"Importante"}
            handleConfirm={() => armazenarCaixa()}
            processo={processo.id}
            caixaCodigo={caixaCodigo}
            dialog={false}
          />
        </>
      }

      {openArmazenaEnvelopeDialog &&
        <>
          <ArmazenarObjetoPostalDialog
            caixaAtual={caixaCodigo}
            erro={erro}
            statusMensagem={statusMensagem}
            close={() => {
              limparCamposParaArmazenarOutroEnvelope();
              setOpenArmazenarEnvelopeDialog(false);
              setErro('');
              setStatusMensagem('');
            }}
            open={openArmazenaEnvelopeDialog}
          />
        </>
      }

      {openDialogMudarEnvelopeDeCaixa &&
				<MudarEnvelopeDeCaixaDialog
					aoFechar={() => {
						limparCamposParaArmazenarOutroEnvelope();
						setOpenDialogMudarEnvelopeDeCaixa(false);
            setLoading(false);
					}}
					aberto={openDialogMudarEnvelopeDeCaixa}
					handlerMudarDeCaixa={armazenamentoEnvelope}
					objetoPostal={objetoPostal}
					ref={dialogMudarEnvelopeDeCaixaRef}
				/>
			}
    </>
  );
}

export default Armazenar;
